import React from "react";
import "./ScoreDetails.scss";
import line from "../../assets/images/Line 484.png";
import darkline from "../../assets/images/Line 502.png";
const ScoreDetails = ({ items }) => {
  return (
    <div className="scoreDetails">
      <div className="score d-md-block d-none">
        {items.map((value, index) => {
          var date = new Date(value.mtm * 1000);
          return (
            <div
              className={`col-10 card ${index % 2 === 0 ? "odd" : ""}`}
              key={index}
            >
              <div className="col-2">
                <span className="title">تعداد : </span>
                {value.count}
              </div>
              {index % 2 === 0 ? (
                <img src={line} alt="line" />
              ) : (
                <img src={darkline} alt="darkline" />
              )}
              <div className="col-2">
                <span className="title">عنوان : </span>
                {value.title}
              </div>
              {index % 2 === 0 ? (
                <img src={line} alt="line" />
              ) : (
                <img src={darkline} alt="darkline" />
              )}
              <div className="col-2">
                <span className="title">زمان : </span>
                {date.toLocaleDateString("fa-IR")}
              </div>
              {index % 2 === 0 ? (
                <img src={line} alt="line" />
              ) : (
                <img src={darkline} alt="darkline" />
              )}
              <div className="col-2">
                <span className="title">فروشگاه : </span>
                {value.shopTitle}
              </div>
            </div>
          );
        })}
      </div>
      <div className="score d-md-none d-block">
        {items.map((value, index) => {
          var date = new Date(value.mtm * 1000);
          return (
            <div
              className={`row card ${index % 2 === 0 ? "odd" : ""}`}
              key={index}
            >
              <div className="col-12 col-sm-6">
                <span className="title">تعداد : </span>
                <span>{value.count}</span>
              </div>
              <br />
              <br />
              <div className="col-12 col-sm-6">
                <span className="title">عنوان : </span>
                <span>{value.title}</span>
              </div>
              <br />
              <br />
              <div className="col-12 col-sm-6">
                <span className="title">زمان : </span>
                <span>{date.toLocaleDateString("fa-IR")}</span>
              </div>
              <br />
              <br />
              <div className="col-12 col-sm-6">
                <span className="title">فروشگاه : </span>
                <span>{value.shopTitle}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default ScoreDetails;
